import styled from 'styled-components';

export const Container = styled.div`
    margin-top: 0px;
    padding: 0 50px;
    border-top: 1px solid #e4ecf6;
    border-bottom-style: none;
    background-color: transparent;
    background-image: linear-gradient(180deg, transparent, transparent);
    
`;

export const InnerContainer = styled.div`
    margin-left: auto;
    margin-right: auto;
    max-width: 990px;
`;

export const Text = styled.p`   
    margin-bottom: 0px;
    padding-top: 15px;
    padding-bottom: 15px;
    font-family: Merriweather, serif;
    color: #9ba4af;
    font-size: 1em;
    line-height: 26px;
    margin-top: 0px;
    font-weight: 500;
`;